import VimeoPlayer from '@vimeo/player';

import getYouTubeApi from '../shared/get-youtube-api';
import getWistiaVideoHandle from '../shared/get-wistia-video-handle';

function restrictYoutubeMedia(iframe) {
  getYouTubeApi(YT => {
    const player = new YT.Player(iframe);

    player.addEventListener('onStateChange', () => player.stopVideo());
  });
}

function restrictVimeoMedia(iframe) {
  const player = new VimeoPlayer(iframe);

  player.unload();
}

function restrictWistiaMedia(iframe) {
  const $iframe = $(iframe);
  const videoId = $iframe.attr('id').match(/wistia_(.*)/)[1];

  getWistiaVideoHandle(videoId, handle => {
    handle.bind('play', () => handle.pause());
  });
}

export default function bootstrap() {
  $(() => {
    // NOTE Soundcloud embeds are handled in `bootstrap-soundcloud-embeds.js`
    // because the iframe is created dynamically

    $('.restricted-by-digital-pass [data-event-type="youtube"] iframe').each((index, iframe) => restrictYoutubeMedia(iframe));
    $('.restricted-by-digital-pass [data-event-type="vimeo"] iframe').each((index, iframe) => restrictVimeoMedia(iframe));
    $('.restricted-by-digital-pass [data-event-type="wistia"] iframe').each((index, iframe) => restrictWistiaMedia(iframe));
  });
}
